import React from 'react';

import { BrandColor } from '@styleseat/brand';
import {
  Box,
  Inline,
  JustifyContentStyleOptions,
} from '@styleseat/ui';
import { BodyText } from '../../ui';
import { SecurityVerifiedIcon } from '../../ui/Icons/SecurityVerifiedIcon';

interface NewProBadgeProps {
  color?: BrandColor;
  justifyContent?: JustifyContentStyleOptions;
  borderRadius?: number;
  iconColor?: string;
  top?: number;
}

export function NewProBadge({
  color = BrandColor.BoneLight,
  justifyContent = 'center' as JustifyContentStyleOptions,
  borderRadius = 4,
  iconColor = BrandColor.BackInBlack,
  top = 2,
}: NewProBadgeProps) {
  return (
    <Box
      color={color}
      borderRadius={borderRadius}
      top={top}
      testID="ss-new-pro"
    >
      <Inline
        space={2}
        alignItems="center"
        justifyContent={justifyContent}
        paddingY={2}
        paddingX={4}
      >
        <Box testID="ss-new-pro-icon">
          <SecurityVerifiedIcon width={20} height={20} color={iconColor} />
        </Box>
        <Box paddingX={4}>
          <BodyText
            appearance="small"
            weight="bold"
            color={BrandColor.BackInBlack}
            testID="ss-new-pro-text"
          >
            New on StyleSeat
          </BodyText>
        </Box>
      </Inline>
    </Box>
  );
}
